export default __webpack_public_path__ + "static/media/roti-roesli-im-garte.e209643b.webp";